import Vue from 'vue'
import { mapState } from 'vuex'
import { messageGroups } from '../plugins/i18n'

// load additional store
import { AdminStore } from 'stylemix-vue-admin'
import zonesModule from './store'
// load routes
import './routes'
// load sidebar menu items
import './sidebar-menu'

AdminStore.registerModule('zones', zonesModule)

// Any component should have access to current division
Vue.mixin({
  computed: {
    ...mapState('zones', ['currentDivision']),
  },
})

messageGroups.push('divisions')
messageGroups.push('zones')
